module.exports = __webpack_public_path__ + "static/Lee_and_Cindy_as_teenager-b5d763317efa651551ce7afecebe8e31.jpg";